// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    body: {
        id: 'hive.actions.my-actions.discover-action.body',
        // prettier-ignore
        defaultMessage: `You haven't set up any actions
yet. But there's no time like the
present.`
    },
    description: {
        id: 'hive.actions.my-actions.discover-action.description',
        // prettier-ignore
        defaultMessage: `Tap Discover to explore all sorts of
wonderful ways you can make your home
work better for you.`
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/discover-splash/intl.js